




















import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { UserSupportPlanDTO } from '../../../src_server/entity/dto/UserSupportPlanDTO';
import { MessageDialog } from '../../utils/MessageDialog';
import SupportPlanDialog from './SupportPlanDialog.vue';
import FileAttachSection from './FileAttachSection.vue';
import SupportPlanBasicStrengthSection from './SupportPlanBasicStrengthSection.vue';
import SupportPlanSection from './SupportPlanSection.vue';
import CourseSelectSection from './CourseSelectSection.vue';
import { StudentService } from '../../biz/remote/StudentService';

@Component({
  components: {
    SupportPlanDialog,
    FileAttachSection,
    SupportPlanBasicStrengthSection,
    SupportPlanSection,
    CourseSelectSection,
  },
})
export default class DaSupportPlanPageCore extends Vue {
  /**
   * Prop
   */
  @Prop({ default: '' })
  private user_id!: string;

  @Prop({ default: false })
  private forDisplay!: boolean;

  /**
   * private
   */
  private dto = new UserSupportPlanDTO();

  /**
   * computed
   */
  get title() {
    return `${this.dto.student.nickname}さん の個別支援計画`;
  }

  async created() {
    const biz = new StudentService();
    const response = await biz.getStudentByUserId(this.user_id);
    this.dto.student = response.data.student;
  }
}
